import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { Opcion } from '../../../infrastructure/services/selects.service';
import { Observable } from 'rxjs/Observable';
import { CategoriaProductosService } from '../../../infrastructure/services/categoria-productos.service';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'sx-selector-categorias',
  templateUrl: 'categorySelector.component.html'
})
export class SelectorCategoriasComponent implements OnInit {
  @Input() required: boolean;
  @Input() valor: any;
  @Input() error: string;
  @Output() seleccionoCategoria: EventEmitter<any> = new EventEmitter();
  $categorias: Observable<Opcion[]>;

  constructor(private categoriasService: CategoriaProductosService, private aRoute: ActivatedRoute) { }

  ngOnInit() {

    this.aRoute.params.subscribe((params: Params) => {
      this.$categorias = this.categoriasService.getForTemplateListado(params['codsistema'])
        .map(categorias => {
          return categorias.map(categoria => {
            return {
              codigo: categoria.id,
              descripcion: categoria.titulo
            } as Opcion;
          });
        });
    });
  }

  seleccionarOpcion(opcion: Opcion) {
    this.seleccionoCategoria.emit(opcion.codigo);
  }

  getDescripcion(opciones: Opcion[], valor) {
    const opcion = opciones.find(opc => opc.codigo === valor);
    if (opcion) {
      return opcion.descripcion;
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/categorySelector/categorySelector.component.ts